import React from 'react'
import { observer } from 'mobx-react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetTitle,
} from 'components/ModalSheet'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from 'components/Table'
import Button from 'components/Button'
import ServiceItemListViewModel, {
  ServiceItem,
} from './ServiceItemListViewModel'
import styles from './ServiceItemListDialog.sass'
import { isNotNil } from 'utils/object-util'
import { formatMoney } from 'utils/money-util'

interface ServiceItemListDialogProps {
  vm: ServiceItemListViewModel
}

export default observer(function ServiceItemListDialog({
  vm,
}: ServiceItemListDialogProps) {
  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader bordered withCloseButton>
        <ModalSheetTitle>
          Service items
          <span className={styles.titleSubtext}>
            {` (${vm.serviceItems.length})`}
          </span>
        </ModalSheetTitle>
      </ModalSheetHeader>
      <ModalSheetContent>
        <Table>
          <TableHead>
            <TableHeader align="left">Name</TableHeader>
            {vm.canSeePriceAsAdmin && (
              <TableHeader align="center">Price</TableHeader>
            )}
            {vm.canSeeProPayoutAsAdmin && (
              <TableHeader align="center">Payout</TableHeader>
            )}
            {vm.canSeePriceAsAdmin && (
              <TableHeader align="center">Courtesy</TableHeader>
            )}
            <TableHeader align="center">Quantity</TableHeader>
          </TableHead>
          <TableBody>
            {vm.serviceItems.map((item, index) => (
              <ServiceItem
                item={item}
                key={index}
                canSeePriceAsAdmin={vm.canSeePriceAsAdmin}
                canSeeProPayoutAsAdmin={vm.canSeeProPayoutAsAdmin}
              />
            ))}
          </TableBody>
        </Table>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button type="default" onClick={vm.close}>
            Close
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})

interface ServiceItemProps {
  item: ServiceItem
  canSeePriceAsAdmin: boolean
  canSeeProPayoutAsAdmin: boolean
}

const ServiceItem = ({
  item,
  canSeePriceAsAdmin,
  canSeeProPayoutAsAdmin,
}: ServiceItemProps) => (
  <TableRow>
    <TableCell align="left">{item.name}</TableCell>
    {canSeePriceAsAdmin && (
      <TableCell align="center">
        {isNotNil(item.clientPrice) ? formatMoney(item.clientPrice) : ''}
      </TableCell>
    )}
    {canSeeProPayoutAsAdmin && (
      <TableCell align="center">
        {isNotNil(item.proPrice) ? formatMoney(item.proPrice) : ''}
      </TableCell>
    )}
    {canSeePriceAsAdmin && (
      <TableCell align="center">
        {isNotNil(item.courtesyQuantity) ? item.courtesyQuantity : ''}
      </TableCell>
    )}
    <TableCell width={100} align="center">
      {item.quantity}
    </TableCell>
  </TableRow>
)
